import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"

import useUserNavigationUtils from "@hooks/useUserNavigationUtils"

import { BottomSheet } from "@organisms"

export default function ProfileBottomSheetWhatsNew() {
    const { openChangelog } = useUserNavigationUtils()

    return (
        <BottomSheet.Item
            onClick={() => openChangelog()}
            icon={icon({ name: "bullhorn", style: "light", family: "sharp" })}
            label={"What's New"}
        />
    )
}
